import axiosInstance from "../api/axiosInstance"

// List with pagination + search
export const fetchHelpSupportList = (params) => {
  return axiosInstance.get("/admin/contact-us", { params });
};

// View by ID
export const fetchHelpSupportById = (id) => {
  return axiosInstance.get(`/admin/contact-us/${id}`);
};

// Delete single
export const deleteHelpSupport = (id) => {
  return axiosInstance.delete(`/admin/contact-us/${id}`);
};

// Bulk delete
export const deleteMultipleHelpSupport = (ids) => {
  return axiosInstance.post("/admin/contact-us/delete-multiple", { ids });
};
